// @flow
import React from 'react';
import { useTranslation } from '@i18n';
import type { CostVariantProps } from './types';

import {
  StyledBarWrapper,
  StyledCostVariantInner,
  StyledCostvariantwrapper,
  StyledGraphBar,
  StyledGraphData,
  StyledName,
  StyledTitlesWrapper
} from '../styles';

const CostVariant = ({
  min_cost,
  max_cost,
  average_cost,
  size
}: CostVariantProps) => {
  const { t } = useTranslation(['Variants']);
  return (
    <StyledCostvariantwrapper size={size}>
      <StyledCostVariantInner>
        <StyledBarWrapper>
          <StyledGraphBar />
          <StyledGraphData>
            {max_cost ? `${max_cost} $` : ''}
          </StyledGraphData>
        </StyledBarWrapper>

        <StyledBarWrapper>
          <StyledGraphBar />
          <StyledGraphData>
            {average_cost ? `${average_cost} $` : ''}
          </StyledGraphData>
        </StyledBarWrapper>

        <StyledBarWrapper>
          <StyledGraphBar />
          <StyledGraphData>
            {min_cost ? `${min_cost} $` : ''}
          </StyledGraphData>
        </StyledBarWrapper>
      </StyledCostVariantInner>
      <StyledTitlesWrapper>
        <StyledName>{t('Max')}</StyledName>
        <StyledName>{t('Avg')}</StyledName>
        <StyledName>{t('Min')}</StyledName>
      </StyledTitlesWrapper>
    </StyledCostvariantwrapper>
  );
};

export default CostVariant;
